import React, { Children, Component } from "react";
import PropTypes from "prop-types";
import {
  reduxForm,
  Field,
  FieldArray,
  formValueSelector,
  change
} from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import ReactTooltip from "react-tooltip";
import {
  FormField,
  Toolbar,
  setSidebarVisibility,
  GET_LIST
} from "admin-on-rest";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import FlatButton from "material-ui/FlatButton";
import Snackbar from "material-ui/Snackbar";
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableFooter
} from "material-ui/Table";
import { Card, CardHeader, CardText } from "material-ui/Card";
import Avatar from "material-ui/Avatar";
import {
  IconEvent,
  IconPayment,
  IconVariant,
  IconAdd,
  IconDelete
} from "../components/mui/icon";
import SelectArrayChipInput from "../components/selectchip";
import { red500 } from "material-ui/styles/colors";
// import { SelectColorChipInput } from "./SelectColorChipInput";
import { SelectProductChipInput } from "./SelectProductChipInput";
import getDefaultValues from "../components/form/getDefaultValues";
import { styles } from "./styles";
import {
  DivErrorMessage,
  DivFormContainer,
  DivFormFieldBox,
  SectionForm,
  DivMain,
  DivSide,
  FullForm
} from "./styled";
import {
  renderMainItemForm,
  renderSideItemForm,
  renderPriceItemForm,
  renderItemFormShipping,
  renderItemFormPaymentMode,
  RenderCard,
  ImagesByVariant
} from "./createfield";
import { RestApiShortUrl, RestClient } from "../restClient";
import { dataColors } from "./styles";
import { isVariant } from "./utils";
import { ValuesForm } from "../components";

import { renderItemFormPlanType } from "./edit";
// import AdvancePrice from "./AdvancePrice";

import SelectProductArrayInput from "./SelectProductArrayInput";

const variantData = [
  { id: "bulan", name: "Bulan" },
  { id: "color", name: "Color" },
  { id: "capacity", name: "Capacity" },
  { id: "collection", name: "Collection" },
  { id: "model", name: "Model" },
  { id: "plan", name: "Plan" },
  { id: "package", name: "Package" },
  { id: "seating", name: "Seating" },
  { id: "schedule", name: "Schedule" },
  { id: "size", name: "Size" },
  { id: "type", name: "Type" },
  { id: "weight", name: "Weight" }
];

class ProductForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => {
      // if(values.payment.bin !== undefined){
      //   let binData = values.payment.bin;
      //   values.payment.bin = binData.map(v=>parseInt(v));
      // }
      this.getSlug(values, redirect);
    });
  constructor(props) {
    super(props);
    this.state = {
      dataItems: variantData,
      open: false,
      message: "Please choice other",
      expandedVariant: true,
      expandedPayment: true,
      expandedProperties: true,
      expandedEvent: true,
      isVariant: false,
      dataCollections: []
    };
  }
  getCollections() {
    RestClient(GET_LIST, "collections", {
      pagination: { page: 1, perPage: 500 },
      sort: { field: "name", order: "ASC" },
      filter: {}
    })
      .then(items => {
        if (items && items.data && items.data.length > 0) {
          this.setState({
            dataCollections: items.data
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  componentWillMount() {
    this.getCollections();
    // this.props.setSidebarVisibility(false);
  }
  getSlug = (values, redirect) => {
    RestApiShortUrl(values.slug)
      .then(response => {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then(data => {
        if (!data.exists) {
          this.props.save(values, redirect);
        } else {
          this.setState({
            open: true,
            message: "The Slug already have"
          });
        }
      })
      .catch(e => {
        this.setState({
          open: true,
          message: "Please try again"
        });
        console.error(e);
      });
  };

  handleExpandVariantChange = expanded => {
    this.setState({ expandedVariant: expanded });
  };
  handleExpandPaymentChange = expanded => {
    this.setState({ expandedPayment: expanded });
  };

  handleExpandEventChange = expanded => {
    this.setState({ expandedEvent: expanded });
  };
  handleRequestClose = () => {
    this.setState({
      open: false
    });
  };

  handleAddVariant = fields => {
    if (this.props.nameProduct === "") {
      this.setState({
        open: true,
        message: "Please fill name of product first"
      });
    } else {
      fields.push({});
    }
  };

  renderItemFormEvent = (children, record, resource, basePath) =>
    Children.map(
      children,
      input =>
        input &&
        (input.props.source === "event.date" ||
          input.props.source === "event.term") && (
          <div
            key={input.props.source}
            className={`aor-input-${input.props.source}`}
            style={input.props.style}
          >
            <FormField
              input={input}
              resource={resource}
              record={record}
              basePath={basePath}
            />
          </div>
        )
    );

  renderOptionsList = ({ fields, meta: { error, submitFailed } }) => {
    return (
      <div>
        <Table selectable={false}>
          <TableBody displayRowCheckbox={false}>
            {fields.map(this.renderOptionsFields)}
          </TableBody>
          <TableFooter adjustForCheckbox={false}>
            <TableRow>
              <TableRowColumn style={{ textAlign: "center" }}>
                <FlatButton
                  primary
                  label="add Options"
                  onClick={() => this.handleAddVariant(fields)}
                  icon={<IconAdd />}
                />
              </TableRowColumn>
            </TableRow>
          </TableFooter>
        </Table>
        {submitFailed && error && <DivErrorMessage> {error} </DivErrorMessage>}
      </div>
    );
  };

  onChangeItem = (event, index, value, input, indexing) => {
    input.onChange(value);
    if (this.props.variant.options.length > 1) {
      const values1 = this.props.variant.options.filter(v => v.name === value);
      if (values1.length !== 0) {
        this.setState({
          open: true,
          message: "Please choice other"
        });
        input.onChange("");
      }
    }
  };
  checkVariant = (variant, name) => {
    const check = isVariant(variant, name, this.props.nameProduct);
    if (this.state.isVariant !== check) {
      setTimeout(() => this.setState({ isVariant: check }), 500);
    }
  };

  onUpdatePhotos = photos => {
    this.props.updatePhotos(photos);
  };

  renderSelectField = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...rest
  }) => (
    <SelectField
      style={styles.selectOptions}
      floatingLabelText={label}
      errorText={touched && error}
      {...input}
      onChange={(event, indexSku, value) =>
        this.onChangeItem(event, indexSku, value, input)
      }
      children={children}
      {...rest}
    />
  );

  renderOptionsFields = (items, index, fields) => (
    <TableRow key={index}>
      <TableRowColumn style={styles.rowOptions}>
        <Field
          key={index}
          label=""
          name={`${items}.name`}
          component={this.renderSelectField}
          placeholder="variant"
        >
          {this.state.dataItems.map((item, indexx) => {
            return (
              <MenuItem value={item.id} key={indexx} primaryText={item.name} />
            );
          })}
        </Field>
      </TableRowColumn>
      <TableRowColumn>
        {this.props.variant.options[index].name === "color" ? (
          <Field
            label=""
            name={`${items}.values`}
            choices={dataColors}
            component={SelectArrayChipInput}
            options={{ fullWidth: true }}
            elStyle={{ marginBottom: 20, marginTop: 0 }}
          />
        ) : (
          <Field
            label=""
            name={`${items}.values`}
            component={SelectProductChipInput}
            elStyle={{ marginBottom: 20, marginTop: 0 }}
          />
        )}
      </TableRowColumn>
      <TableRowColumn style={styles.rowFooter}>
        <FlatButton
          primary
          label=""
          style={styles.removeButton}
          onClick={() => fields.remove(index)}
          icon={<IconDelete />}
        />
      </TableRowColumn>
    </TableRow>
  );

  renderVariantPaymentShippingEvent = (
    children,
    record,
    resource,
    basePath
  ) => (
    <div style={{ marginTop: 16 }}>
      <Card
        expanded={this.state.expandedVariant}
        onExpandChange={this.handleExpandVariantChange}
        style={{ marginBottom: 16 }}
      >
        <CardHeader
          title="Variants"
          subtitle=""
          avatar={<Avatar icon={<IconVariant />} />}
          actAsExpander={true}
          showExpandableButton={true}
        />
        <CardText expandable={true}>
          <div>
            <FieldArray
              name="variant.options"
              component={this.renderOptionsList}
            />
          </div>
        </CardText>
      </Card>
    </div>
  );
  renderSideItemFormCollection(
    children,
    record,
    resource,
    basePath,
    translate
  ) {
    //console.log(this.state.dataCollections);
    return (
      <div>
        <Field
          label={"Collection"}
          name={"collections"}
          component={SelectProductArrayInput}
          choices={this.state.dataCollections}
          dataOptions={this.props.collections}
          elStyle={{ marginBottom: 20, marginTop: 0 }}
        />
      </div>
    );
  }
  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar,
      nameProduct,
      tagsProduct,
      variant
    } = this.props;
    this.checkVariant(variant, nameProduct);
    return (
      <div>
        <form className="simple-form">
          <DivFormContainer>
            <SectionForm>
              <DivMain>
                <RenderCard title="">
                  <DivFormFieldBox>
                    {renderMainItemForm(children, record, resource, basePath)}
                    <ReactTooltip
                      id="slugtooltip"
                      type="error"
                      aria-haspopup="true"
                      place="top"
                    >
                      <span>Such as 'samsungs8' will be ola.id/samsungs8</span>
                    </ReactTooltip>
                  </DivFormFieldBox>
                </RenderCard>
                <RenderCard title="Price">
                  {renderPriceItemForm(children, record, resource, basePath)}
                  <ReactTooltip
                    id="discounttooltip"
                    type="error"
                    aria-haspopup="true"
                    place="top"
                  >
                    <span>0.1 for 10% discount or 20000 for amount</span>
                  </ReactTooltip>
                  {/* {<AdvancePrice {...this.props} />} */}
                </RenderCard>
              </DivMain>
              <DivSide>
                {
                  <RenderCard title="">
                    <DivFormFieldBox>
                      {renderSideItemForm(children, record, resource, basePath)}
                      {this.renderSideItemFormCollection(
                        children,
                        record,
                        resource,
                        basePath
                      )}
                      <ReactTooltip
                        id="sort_ordertooltip"
                        type="error"
                        aria-haspopup="true"
                        place="top"
                      >
                        <span>Higher number will be showing first</span>
                      </ReactTooltip>
                    </DivFormFieldBox>
                  </RenderCard>
                }
                {this.props.productType === "Indosat MSP" && (
                  <Card
                    expanded={this.state.expandedEvent}
                    onExpandChange={this.handleExpandEventChange}
                    style={{ marginBottom: 16 }}
                  >
                    <CardHeader
                      title="Plan Type"
                      subtitle=""
                      avatar={<Avatar icon={<IconEvent />} />}
                      actAsExpander={true}
                      showExpandableButton={true}
                    />
                    <CardText expandable={true}>
                      <div>
                        {renderItemFormPlanType(
                          children,
                          record,
                          resource,
                          basePath
                        )}
                      </div>
                    </CardText>
                  </Card>
                )}

                {this.props.productType === "Ticket" && (
                  <Card
                    expanded={this.state.expandedEvent}
                    onExpandChange={this.handleExpandEventChange}
                    style={{ marginBottom: 16 }}
                  >
                    <CardHeader
                      title="Event"
                      subtitle=""
                      avatar={<Avatar icon={<IconEvent />} />}
                      actAsExpander={true}
                      showExpandableButton={true}
                    />
                    <CardText expandable={true}>
                      <div>
                        {this.renderItemFormEvent(
                          children,
                          record,
                          resource,
                          basePath
                        )}
                      </div>
                    </CardText>
                  </Card>
                )}

                <Card
                  expanded={this.state.expandedPayment}
                  onExpandChange={this.handleExpandPaymentChange}
                  style={{ marginBottom: 16 }}
                >
                  <CardHeader
                    title="Payment Mode"
                    subtitle=""
                    avatar={<Avatar icon={<IconPayment />} />}
                    actAsExpander={true}
                    showExpandableButton={true}
                  />
                  <CardText expandable={true}>
                    <div>
                      {renderItemFormPaymentMode(
                        children,
                        record,
                        resource,
                        basePath
                      )}
                    </div>
                  </CardText>
                </Card>
                <RenderCard title="Shipping">
                  {renderItemFormShipping(children, record, resource, basePath)}
                </RenderCard>
              </DivSide>
            </SectionForm>
            <FullForm>
              {this.renderVariantPaymentShippingEvent(
                children,
                record,
                resource,
                basePath
              )}
            </FullForm>
            {this.state.isVariant && (
              <FullForm>
                <ImagesByVariant
                  variant={variant}
                  onUpdatePhotos={this.onUpdatePhotos.bind(this)}
                  nameProduct={nameProduct}
                  tagsProduct={tagsProduct}
                />
              </FullForm>
            )}
          </DivFormContainer>

          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
        </form>
        <Snackbar
          open={this.state.open}
          message={this.state.message}
          autoHideDuration={4000}
          bodyStyle={{ backgroundColor: red500 }}
          onRequestClose={this.handleRequestClose}
        />
        <ValuesForm isDebug={false} />
      </div>
    );
  }
}

ProductForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func
};

ProductForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};

const selector = formValueSelector("record-form");

const enhance = compose(
  connect(
    (state, props) => {
      const variant = selector(state, "variant");
      const nameProduct = selector(state, "name");
      const tagsProduct = selector(state, "tags");
      const productType = selector(state, "product_type");
      const collections = selector(state, "collections");
      return {
        initialValues: {
          shipping: {},
          event: {},
          collections: [],
          ...getDefaultValues(state, props)
        },
        variant,
        productType,
        tagsProduct,
        nameProduct,
        collections
      };
    },
    {
      setSidebarVisibility,
      updatePhotos: photos => change("record-form", "photos", photos)
    }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true
  })
);

export default enhance(ProductForm);



// WEBPACK FOOTER //
// ./src/products/ProductForm.js